import { Injectable } from '@angular/core';
import { WSService } from 'projects/core/src/include/service';
import { DossierOverview } from '../dossier';
import { Observable } from 'rxjs';
import { Globals } from 'projects/core/src/globals';

@Injectable({
  providedIn: 'root'
})
export class DossierOverviewsService extends WSService<DossierOverview> {

  constructor() { super("dossieroverviews");}

  getOverviews(id_type):Observable<any>{
    return Globals.ws.requestUrl("dossieroverviews","getOverviews",[id_type]);
  }

}
